import { Col, Row, Spin, Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { Alerta } from "../../../../constants";
import { useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router";
import ActionBar from "../../../../components/action-bar";
import ActionButton from "../../../../components/action-button";
import TextAnexo from "../../../../components/text-anexo";
import TextItem from "../../../../components/text-item";
import { EmpresaProcurador, findByIdAndMap } from "../../../../constants";
import useFormatter from "../../../../hooks/useFormatter";
import useLoading from "../../../../hooks/useLoading";
import {
  fetchProcurador,
  isEditableSelector,
  procuradoreSelector,
} from "../../../../store/empresa";
import { openPopup, openPopupAssinaturas } from "../../../../util/window";
import useModulo from "../../../../hooks/useModulo";
import { procuradoresAlertaNivelSelector } from "../../../../store/empresa";
import TarefasDrawer from "../../licencas/_tarefasDrawer";
import { useLocation } from "react-router";
import { useState } from "react";
import useDispatchWithResult from "../../../../hooks/useDispatchWithResult";
import { verificarAssinatura } from "../../../../store/assinatura";
const { Tipo, Representacao } = EmpresaProcurador;

export default function EmpresaProcuradorDetailPage() {
  const { t } = useTranslation();
  const isEditable = useSelector(isEditableSelector);
  const procurador = useSelector(procuradoreSelector);
  const { formatDate, formatDateTime, formatBoolean } = useFormatter();
  const loading = useLoading(fetchProcurador.typePrefix);
  const history = useHistory();
  const nivel = useSelector(procuradoresAlertaNivelSelector);
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;
  const dispatch = useDispatchWithResult();
  const { moduloBasePath } = useModulo();
  const location = useLocation();
  const pathname = location.pathname;
  const origem = pathname.substring(pathname.indexOf("/empresas"));
  const modulo = pathname.split("/")[1];
  const [tarefasDrawerVisible, setTarefasDrawerVisible] = useState(false);

  const isNA =
    nivel === Alerta.Nivel.NA.id || nivel === Alerta.Nivel.inativo.id;

  const handleOpenPopupAssinaturas = () => {
    const anexo = procurador?.anexo;
    const uid = anexo?.uid;

    dispatch(verificarAssinatura())
      .then((response) => {
        if (!uid || !uid.includes("/")) {
          response.error("É necessário salvar o anexo antes da assinatura.");
          return;
        }
        openPopupAssinaturas(uid, empresaId);
      })
      .catch((response) => {
        Modal.error({
          title: "Erro ao enviar para assinatura",
          content: response.mensagem,
          centered: true,
        });
      });
  };

  const handleEdit = () => {
    history.replace(
      `${moduloBasePath}/empresas/${empresaId}/procuradores/${id}/edit`
    );
  };

  const handleBack = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/procuradores`);
  };

  const handleLogs = () => {
    openPopup(
      `/logs?categoria=/empresas/${empresaId}/procuradores/${id}/`,
      `logs_/empresas/${empresaId}/procuradores/${id}/`
    );
  };
  return (
    <Spin spinning={loading}>
      <TarefasDrawer
        visible={tarefasDrawerVisible}
        origem={origem}
        modulo={modulo}
        empresaId={empresaId}
        onClose={() => setTarefasDrawerVisible(false)}
      />
      <ActionBar>
        <ActionButton.Tarefa
          disabled={isNA}
          onClick={() => setTarefasDrawerVisible(true)}
        />
        {isEditable && (
          <ActionButton.Edit onClick={handleEdit} disabled={isNA} />
        )}
        <ActionButton.Back onClick={handleBack} />
        <ActionButton.Logs noTitle onClick={handleLogs} />
      </ActionBar>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label={t("Tipo")}>
            {findByIdAndMap(Tipo, procurador?.tipo, (tipo) => t(tipo.label))}
          </TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t("Representação")}>
            {findByIdAndMap(
              Representacao,
              procurador?.representacao,
              (representacao) => t(representacao.label)
            )}
          </TextItem>
        </Col>
      </Row>
    <Row gutter={[16, 8]}>
  <Col flex="800px">
    <div style={{  marginBottom: 8 }}>
      {t("Nomes")}
    </div>
    {(procurador?.nomes || []).map((it, index) => {
  let nome = "";
  let cpf = "";
  let email = "";
  try {
    const parsed = typeof it === "string" ? JSON.parse(it) : it;
    nome = parsed?.nome || "";
    cpf = parsed?.cpf || "";
    email = parsed?.email || "";
  } catch {
    nome = it;
  }

  const showLabel = index === 0; 

  return (
    <Row key={index} gutter={[16, 8]} style={{ marginBottom: 4 }}>
      <Col flex="200px">
        <TextItem label={showLabel ? t("Nome") : undefined}>{nome}</TextItem>
      </Col>
      <Col flex="200px">
        <TextItem label={showLabel ? t("CPF") : undefined}>{cpf}</TextItem>
      </Col>
      <Col flex="200px">
        <TextItem label={showLabel ? t("Email") : undefined}>{email}</TextItem>
      </Col>
    </Row>
  );
})}
  </Col>
</Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label={t("Data Inicial")}>
            {formatDate(procurador?.dataInicial)}
          </TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t("Prazo Indeterminado")}>
            {formatBoolean(procurador?.indeterminado)}
          </TextItem>
        </Col>
        {procurador?.indeterminado === false && (
        <Col flex="200px">
          
            <TextItem label={t("Data Final")}>
              {formatDate(procurador?.dataFinal)}
            </TextItem>
        </Col>
        )}
        <Col flex="200px">
          <TextItem label={t("Controle de Prazo")}>
            {formatBoolean(procurador?.aviso)}
          </TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <TextItem label={t("Poderes")}>{procurador?.poderes}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]} alignItems="center">
        <Col flex="200px">
          <TextAnexo label={t("Anexo")} value={procurador?.anexo} />
        </Col>
        {procurador?.anexo &&  <Col flex="200px">
          <ActionButton.Assinatura
            onClick={handleOpenPopupAssinaturas}
            style={{ marginTop: "11px" }}
          />
        </Col>}
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <TextItem label={t("Observação")}>{procurador?.obs}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label="Criado em">
            {formatDateTime(procurador?.createdAt)}
          </TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label="Alterado em">
            {formatDateTime(procurador?.updatedAt)}
          </TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label="Id">{empresaId}</TextItem>
        </Col>
      </Row>
    </Spin>
  );
}
